"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-labels */
var orderBy_1 = __importDefault(require("lodash/orderBy"));
var data_1 = require("./data");
function validarPorAlcada(agenteRegraAssinatura) {
    return agenteRegraAssinatura.every(function (_a) {
        var alcada = _a.alcada;
        return alcada === true;
    });
}
var AssinaturaUtil = /** @class */ (function () {
    function AssinaturaUtil() {
    }
    AssinaturaUtil.isValidRegrasAssinatura = function (input) {
        if (input.agenteRegraAssinatura.length === 0) {
            return false;
        }
        var totalAssinantesRL = input.tiposAssinanteAssinatura.filter(function (tipo) { return tipo === data_1.TipoAssinanteRegra.REPRESENTANTE_LEGAL; }).length;
        var totalAssinantesProcurador = input.tiposAssinanteAssinatura.filter(function (tipo) { return tipo === data_1.TipoAssinanteRegra.PROCURADOR; }).length;
        if (validarPorAlcada(input.agenteRegraAssinatura)) {
            var regraAssinaturaOrdernada = orderBy_1.default(input.agenteRegraAssinatura, 'assinaturaRegra.valor', 'asc');
            var regraDaAlcada = null;
            outer: for (var _i = 0, regraAssinaturaOrdernada_1 = regraAssinaturaOrdernada; _i < regraAssinaturaOrdernada_1.length; _i++) {
                var regraAssinatura = regraAssinaturaOrdernada_1[_i];
                for (var _a = 0, _b = regraAssinatura.assinaturaRegra; _a < _b.length; _a++) {
                    var regra = _b[_a];
                    if (input.valorContrato <= regra.valor) {
                        regraDaAlcada = regra;
                        break outer;
                    }
                }
            }
            if (!regraDaAlcada) {
                return false;
            }
            return totalAssinantesRL === regraDaAlcada.numeroAssinantes && totalAssinantesProcurador === 0;
        }
        /**
         * agenteRegraAssinatura devem ser validadas como OU e assinaturaRegra devem
         * ser validadas como E.
         */
        return input.agenteRegraAssinatura.some(function (regra) {
            return regra.assinaturaRegra.every(function (_a) {
                var tipoAssinante = _a.tipoAssinante, numeroAssinantes = _a.numeroAssinantes;
                if (tipoAssinante === data_1.TipoAssinanteRegra.REPRESENTANTE_LEGAL) {
                    return numeroAssinantes === totalAssinantesRL;
                }
                if (tipoAssinante === data_1.TipoAssinanteRegra.PROCURADOR) {
                    return numeroAssinantes === totalAssinantesProcurador;
                }
                throw new Error("tipo assinante inv\u00E1lido: " + tipoAssinante);
            });
        });
    };
    return AssinaturaUtil;
}());
exports.default = AssinaturaUtil;
